module.exports = __webpack_public_path__ + "static/media/smile3.117a081d.gif";